module.exports = __webpack_public_path__ + "img/MSI2025.606ba8da.png";